import { createSelector } from '@ngrx/store';
import { AppState, TrialsState } from '@ra-state';

export const trialsFeature = (state: AppState): TrialsState => state.trials;
export const selectTrialsState = createSelector(trialsFeature, (state: TrialsState) => state);

export const selectCampaignDetails = createSelector(trialsFeature, (state: TrialsState) => state.campaignDetails);
export const selectTrialBundles = createSelector(trialsFeature, (state: TrialsState) => state.trialBundles);

export const selectRefreshTrialGrid = createSelector(trialsFeature, (state: TrialsState) => state.refreshGrid);
